export function setAddinAutoshow() {
    const documentSettings = Office.context.document.settings;
    /* eslint-disable-next-line more/no-hardcoded-configuration-data */
    const autoshowSetting = 'Office.AutoShowTaskpaneWithDocument';

    documentSettings.set(autoshowSetting, true);
    documentSettings.saveAsync();
}
